import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { PersonConfirmationDto, PersonDataBasicDto, PersonCorrectionDto } from '../interfaces/IPersonDataBasicDto';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { MiAdmPersonas } from '../interfaces/IAdmPersonas';
import { IUpdPersonInfoRapida } from '../interfaces/IUpdPersonInfoRapida';

@Injectable({
    providedIn: 'root'
})
export class PersonService {
    private apiUrl = environment.backUrlApi + 'Person';
    private http = inject(HttpClient);

    updateBasicData(form: FormData): Observable<ResponseModel<MiAdmPersonas>> {
        return this.http.put<ResponseModel<MiAdmPersonas>>(`${this.apiUrl}/data-basic`, form);
    }
    confirmPreRegister(body: PersonConfirmationDto): Observable<ResponseModel<MiAdmPersonas>> {
        return this.http.put<ResponseModel<MiAdmPersonas>>(`${this.apiUrl}/confirm-pre-register`, body);
    }
    correctionIdentification(body: PersonCorrectionDto): Observable<ResponseModel<MiAdmPersonas>> {
        return this.http.put<ResponseModel<MiAdmPersonas>>(`${this.apiUrl}/correction-identification`, body);
    }
    getByIdentification(tipoIdentificacion: number, identification: string): Observable<ResponseModel<MiAdmPersonas>> {
        return this.http.get<ResponseModel<MiAdmPersonas>>(`${this.apiUrl}/by-identification/${tipoIdentificacion}/${identification}`);
    }
    getAllActivePerson(value: string): Observable<ResponseModel<MiAdmPersonas[]>> {
        return this.http.get<ResponseModel<MiAdmPersonas[]>>(`${this.apiUrl}/all-active/${value}`);
    }
    updateInfoRapida(payload: IUpdPersonInfoRapida) {
        return this.http.put<ResponseModel<MiAdmPersonas>>(`${this.apiUrl}/update-info-rapida`, payload);
    }
     updateBasicDataAditional(form: FormData): Observable<ResponseModel<MiAdmPersonas>> {
        return this.http.put<ResponseModel<MiAdmPersonas>>(`${this.apiUrl}/data-basic-aditional`, form);
    }
}
